import styled from "styled-components";

interface SectionTitleSeparatorProps {
  position: "right" | "left";
}

export default styled.div<SectionTitleSeparatorProps>`
  box-sizing: content-box;
  position: absolute;
  bottom: -8px;
  width: 100%;
  height: 8px;
  background-color: #a6be0a;

  ${({ position }) =>
    position === "right" &&
    `
    padding: 0 34px 0 72px;
    left: -72px;
  `}

  ${({ position }) =>
    position === "left" &&
    `
    padding: 0 157px 0 34px;
    left: -34px;
  `}
`;
